function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F7DD88"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2 12.9H25.25V11H23.35V12.9H15.75V11H13.85V12.9H12.9C11.8503 12.9 11.0095 13.7502 11.0095 14.8L11 28.1C11 29.1497 11.8502 30 12.9 30H26.2C27.2498 30 28.1 29.1498 28.1 28.1V14.8C28.1 13.7502 27.2498 12.9 26.2 12.9ZM26.2 28.1H12.9V17.65H26.2V28.1Z",
  fill: "#FF993A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8515 20.5578L22.8445 19.5508L18.2085 24.1868L16.1945 22.1728L15.1875 23.1798L18.2085 26.2008L23.8515 20.5578Z",
  fill: "#FF993A"
});

var SvgReschedulerequest = function SvgReschedulerequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReschedulerequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reschedulerequest.a75951ec.svg";
export { ForwardRef as ReactComponent };